import React, { PropTypes } from 'react'

import { connect } from 'react-redux'
import moment from 'moment-timezone';
import { fetchDataIfNeeded } from '../../actions/UsercardBookingAction';
import BigBreadcrumbs from '../../components/layout/navigation/components/BigBreadcrumbs.jsx'
import WidgetGrid from '../../components/layout/widgets/WidgetGrid.jsx'
import JarvisWidget from '../../components/layout/widgets/JarvisWidget.jsx'
import Datatable from '../../components/tables/Datatable.jsx'

class BookingCount extends React.Component{

  constructor(props) {
    super(props);
    this.state = {graphData: {}, data:{}};
  }

  componentDidMount() {

    this.props.dispatch(fetchDataIfNeeded());

  }

  render(){
    return <div id="content">
                <div className="row">
                    <BigBreadcrumbs items={['Table', 'Data Tables']} icon="table"
                                    className="col-xs-12 col-sm-7 col-md-7 col-lg-4"/>
                </div>

                <WidgetGrid>

                    <div className="row">
                        <article className="col-sm-12">

                            <JarvisWidget editbutton={false} color="blueDark">
                                <header>
                                    <span className="widget-icon"> <i className="fa fa-table"/> </span>
                                    <h2>予約</h2>
                                </header>
                                <div>
                                    <div className="widget-body no-padding">
                                        <Datatable
                                            data = {this.props.data}
                                            options={{
                                                order: [[ 0, 'desc' ]],
                                                columns: [
                                                  {data: "book_date"},
                                                  {data: "epark_shop_id"},
                                                  {data: "name"},
                                                  {data: "phone_number"},
                                                  {data: "book_type_name"}
                                                ],
                                                buttons: [
                                                    {
                                                      extend: 'csv',
                                                      bom: true
                                                    },
                                                    'copy', 'excel', 'pdf'
                                                ],
                                                "pageLength": 20
                                            }}
                                            className="table table-striped table-bordered table-hover"
                                            width="100%">
                                            <thead>
                                              <tr>
                                                  <th >日付</th>
                                                  <th >EPARKショップID</th>
                                                  <th >店舗名</th>
                                                  <th >電話番号</th>
                                                  <th >予約手法(Web/PPC)</th>
                                              </tr>
                                            </thead>

                                        </Datatable>

                                    </div>
                                </div>
                            </JarvisWidget>
                        </article>

                    </div>

                </WidgetGrid>
            </div>;
  }
}

const mapStateToProps = (state) => {

  const { usercardBooking } = state;

  usercardBooking.data.forEach(item=>{

    let bookDate =moment(item.created_at);

    item.book_date = bookDate.tz('Asia/Tokyo').format('YYYY-MM-DD HH:mm:ss');

    if(item.book_type === 1)
      item.book_type_name = 'Web'
    else {
      item.book_type_name = 'PPC'
    }
    
  });

  return {
    data: usercardBooking.data,
    isFetching: state.usercardCount.isFetching
  }
}

export default connect(mapStateToProps)(BookingCount);



// WEBPACK FOOTER //
// ./src/pages/collectdata/BookingCount.js